import React, { useState, useRef, forwardRef, useImperativeHandle } from 'react';
import { Rnd } from 'react-rnd';
import SignatureCanvas from 'react-signature-canvas';
import { PDFDocument } from 'pdf-lib';
import { message } from 'antd';
// === IMPORT THƯ VIỆN REACT-PDF ===
import { Document, Page, pdfjs } from 'react-pdf';
import { ChevronUp, ChevronDown, Trash2, Download, Printer, Menu, Settings } from 'lucide-react';

// Cấu hình Worker cho react-pdf
pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

// === STYLES === 
const styles = {
    container: { display: 'flex', flexDirection: 'column' as const, height: '100vh', fontFamily: 'Segoe UI, Roboto, Helvetica, Arial, sans-serif', backgroundColor: '#f0f2f5', color: '#333', overflow: 'hidden' },
    header: { backgroundColor: '#3E91AB', color: 'white', padding: '8px 16px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', boxShadow: '0 2px 4px rgba(0,0,0,0.1)', zIndex: 10, flexWrap: 'wrap' as const, gap: '8px' },
    headerLeft: { display: 'flex', alignItems: 'center', gap: '10px' },
    menuIcon: { cursor: 'pointer', fontSize: '18px', display: 'flex', alignItems: 'center' },
    fileName: { backgroundColor: 'white', color: '#3E91AB', padding: '4px 8px', borderRadius: '4px', fontWeight: 'bold', fontSize: '13px', display: 'flex', alignItems: 'center', gap: '6px', cursor: 'pointer' },
    headerCenter: { display: 'flex', alignItems: 'center', gap: '10px', fontSize: '13px' },
    headerRight: { display: 'flex', alignItems: 'center', gap: '8px' },
    iconBtn: { color: 'white', cursor: 'pointer', fontSize: '16px', padding: '4px', borderRadius: '4px', transition: 'background-color 0.2s', display: 'flex', alignItems: 'center', justifyContent: 'center' },
    zoomSelect: { backgroundColor: 'transparent', color: 'white', border: 'none', fontSize: '13px', fontWeight: 'bold', cursor: 'pointer', outline: 'none' },
    zoomOption: { color: '#333', backgroundColor: '#fff' },
    main: { flex: 1, display: 'flex', overflow: 'hidden', position: 'relative' as const },

    thumbnailSidebar: { width: '130px', backgroundColor: '#f8f9fa', borderRight: '1px solid #ddd', padding: '10px', overflowY: 'auto' as const, display: 'flex', flexDirection: 'column' as const, gap: '10px', alignItems: 'center', zIndex: 5 },
    thumbnailItem: { width: '100px', display: 'flex', flexDirection: 'column' as const, alignItems: 'center', gap: '4px', cursor: 'pointer', padding: '4px', borderRadius: '4px', transition: '0.2s' },
    thumbnailActive: { border: '2px solid #3E91AB', backgroundColor: '#e6f0fa' },
    thumbnailText: { fontSize: '10px', color: '#666', fontWeight: 'bold' },

    // 1. Cho phép cuộn ngang bình thường nhưng thêm padding xung quanh để tạo khoảng hở lề
    pdfViewer: {
        flex: 1,
        backgroundColor: '#f0f2f5',
        overflow: 'auto' as const, // Vẫn giữ nguyên cuộn ngang/dọc đầy đủ
        display: 'block',          // Đổi sang block để margin auto hoạt động chuẩn xác
        WebkitOverflowScrolling: 'touch' as const
    },

    // 2. Ép trang PDF luôn căn giữa bằng margin auto, có khoảng cách với mép màn hình
    pdfPage: {
        backgroundColor: 'white',
        boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
        position: 'relative' as const,
        border: '1px solid #ddd',
        boxSizing: 'border-box' as const,
        display: 'flex',
        flexDirection: 'column' as const,
        alignItems: 'center',
        width: '794px',
        margin: '0 auto', // Tự động căn giữa, nếu rộng quá sẽ có khoảng trống đều hai bên và hiện cuộn ngang mượt mà
    },

    toolsSidebar: { width: '280px', backgroundColor: 'white', borderLeft: '1px solid #ddd', display: 'flex', flexDirection: 'column' as const, overflowY: 'auto' as const, transition: '0.3s', zIndex: 5 },
    toolsTabHeader: { display: 'flex', borderBottom: '1px solid #eee' },
    toolsTabItem: { flex: 1, padding: '10px', textAlign: 'center' as const, cursor: 'pointer', fontSize: '13px', color: '#666', fontWeight: 'bold', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '6px' },
    toolsTabItemActive: { color: '#3E91AB', borderBottom: '2px solid #3E91AB' },
    toolsTabContent: { padding: '16px 12px', display: 'flex', flexDirection: 'column' as const, gap: '16px' },
    section: { display: 'flex', flexDirection: 'column' as const, gap: '8px' },
    sectionTitle: { fontSize: '13px', fontWeight: 'bold', color: '#333' },

    profileSelector: { display: 'flex', alignItems: 'center', gap: '8px', padding: '6px 10px', backgroundColor: '#f8f9fa', borderRadius: '4px', border: '1px solid #eee' },
    realSelect: { flex: 1, border: 'none', backgroundColor: 'transparent', fontSize: '13px', color: '#333', outline: 'none', cursor: 'pointer', fontWeight: 'bold' },
    profileAvatar: { width: '24px', height: '24px', borderRadius: '50%', backgroundColor: '#3E91AB', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '11px', color: 'white' },

    signatureOptions: { display: 'flex', gap: '10px', justifyContent: 'center' },
    signatureBtn: { display: 'flex', flexDirection: 'column' as const, alignItems: 'center', gap: '6px', padding: '10px', width: '90px', backgroundColor: '#f8f9fa', border: '1px solid #eee', borderRadius: '4px', cursor: 'pointer', textAlign: 'center' as const, transition: '0.2s' },
    signatureIcon: { fontSize: '18px', color: '#3E91AB' },
    signatureText: { fontSize: '11px', color: '#333', fontWeight: 'bold' },

    footer: { backgroundColor: 'white', borderTop: '1px solid #ddd', padding: '10px 16px', display: 'flex', justifyContent: 'flex-end', gap: '10px', boxShadow: '0 -2px 4px rgba(0,0,0,0.02)', zIndex: 5 },
    footerBtn: { padding: '8px 18px', borderRadius: '20px', border: '1px solid #ddd', cursor: 'pointer', fontSize: '13px', fontWeight: 'bold', transition: '0.2s' },
    saveBtn: { backgroundColor: '#3E91AB', color: 'white', border: 'none', display: 'flex', alignItems: 'center', gap: '6px' },
    cancelBtn: { backgroundColor: 'white', color: '#d10000', borderColor: '#d10000' },

    sigBox: { border: '2px solid #3E91AB', backgroundColor: 'rgba(0, 61, 109, 0.1)', display: 'flex', flexDirection: 'column' as const, alignItems: 'center', justifyContent: 'center', cursor: 'move', borderRadius: '4px', overflow: 'visible' as const, touchAction: 'none' as const, zIndex: 50 },
    sigBoxSigned: { border: '2px dashed #ccc', backgroundColor: 'rgba(250, 250, 250, 0.5)' },
    sigRole: { fontSize: '10px', fontWeight: 'bold', color: '#333', textAlign: 'center' as const, padding: '0 4px', whiteSpace: 'nowrap' as const, overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: '100%' },
    sigType: { fontSize: '11px', color: '#3E91AB', fontStyle: 'italic', marginTop: '2px' },
    sigDelete: { position: 'absolute' as const, top: '-10px', right: '-10px', background: '#d10000', color: 'white', border: 'none', borderRadius: '50%', width: '22px', height: '22px', fontSize: '11px', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 'bold', zIndex: 5 },
    sigDragHandle: { position: 'absolute' as const, bottom: '-10px', left: '-10px', background: '#fff', color: '#3E91AB', border: '1px solid #3E91AB', borderRadius: '50%', width: '24px', height: '24px', fontSize: '12px', cursor: 'move', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 5, boxShadow: '0 2px 4px rgba(0,0,0,0.1)' },
    sigClickToSign: { fontSize: '10px', color: '#3E91AB', fontWeight: 'bold', marginTop: '4px', backgroundColor: '#fff', border: '1px solid #3E91AB', padding: '2px 6px', borderRadius: '10px', cursor: 'pointer' },
    signedImage: { width: '100%', height: '100%', objectFit: 'fill' as const, cursor: 'pointer' },

    modalOverlay: { position: 'fixed' as const, top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1000, padding: '16px', boxSizing: 'border-box' as const },
    modalContent: { backgroundColor: 'white', padding: '20px', borderRadius: '8px', boxShadow: '0 4px 16px rgba(0,0,0,0.2)', width: '100%', maxWidth: '400px', textAlign: 'center' as const },
    modalTitle: { fontSize: '16px', fontWeight: 'bold', color: '#3E91AB', marginBottom: '12px' },
    signatureCanvasArea: { border: '1px solid #ddd', backgroundColor: '#f9f9f9', borderRadius: '4px', marginBottom: '16px', touchAction: 'none' as const },
    modalActions: { display: 'flex', justifyContent: 'center', gap: '10px' },
    modalBtn: { padding: '8px 14px', borderRadius: '4px', border: '1px solid #ddd', cursor: 'pointer', fontSize: '13px', fontWeight: 'bold' },
    modalBtnPrimary: { backgroundColor: '#3E91AB', color: 'white', border: 'none' },
    modalBtnClear: { backgroundColor: '#f0f2f5', color: '#333', border: 'none' },

    accItem: { border: '1px solid #e0e0e0', borderRadius: '6px', marginBottom: '10px', overflow: 'hidden', backgroundColor: '#fff' },
    accHeader: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '10px', cursor: 'pointer', backgroundColor: '#fff' },
    accHeaderLeft: { display: 'flex', alignItems: 'center', gap: '8px' },
    accIcon: { width: '28px', height: '28px', borderRadius: '50%', backgroundColor: '#f0f7ff', color: '#007bff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '13px' },
    accTitleArea: { display: 'flex', flexDirection: 'column' as const },
    accTitleMain: { fontSize: '12px', fontWeight: 'bold', color: '#333' },
    accTitleSub: { fontSize: '10px', color: '#888', marginTop: '2px' },
    accToggleBtn: { color: '#007bff', fontSize: '14px', fontWeight: 'bold' },
    accBody: { padding: '10px', borderTop: '1px solid #f0f0f0', display: 'flex', flexDirection: 'column' as const, alignItems: 'center', position: 'relative' as const },
    accImagePlaceholder: { width: '100%', height: '70px', backgroundColor: '#f5f5f5', border: '2px dashed #ddd', borderRadius: '4px', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#ccc', fontSize: '20px' },
    accImageReal: { width: '100%', height: '100%', objectFit: 'fill' as const },
    accDeleteBtn: { position: 'absolute' as const, bottom: '6px', right: '6px', color: '#007bff', cursor: 'pointer', fontSize: '14px', background: 'none', border: 'none', padding: '4px' }
};

export interface DocumentSignRef {
  handleSaveAll: () => void;
}

const DocumentSign = forwardRef<DocumentSignRef>((props, ref) => {
    const [pageSize, setPageSize] = useState({ width: 792, height: 1123 });
    const [numPages, setNumPages] = useState<number>(1);
    const [currentPage, setCurrentPage] = useState(1);
    const [activeTab, setActiveTab] = useState('tools');
    const [zoom, setZoom] = useState('100');
    const [signatures, setSignatures] = useState<any[]>([]);
    const [selectedSigner, setSelectedSigner] = useState('Giám đốc - Nguyễn Văn A');
    const [expandedSigs, setExpandedSigs] = useState<number[]>([]);

    const [showThumbnails, setShowThumbnails] = useState(window.innerWidth > 768);
    const [showTools, setShowTools] = useState(false);

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [currentSigningId, setCurrentSigningId] = useState<number | null>(null);
    const sigCanvasRef = useRef<any>({});

    function onDocumentLoadSuccess({ numPages }: { numPages: number }) {
        setNumPages(numPages);
    }

    const thumbnails = Array.from(new Array(numPages), (el, index) => ({
        page: index + 1,
        text: `Trang ${index + 1 < 10 ? '0' : ''}${index + 1}`
    }));

    const handleAddSignature = (type: string) => {
        const newSig = {
            id: Date.now(),
            type: type,
            signer: selectedSigner,
            page: currentPage,
            x: 316,
            y: 950,
            width: 160,
            height: 80,
            realSignature: null,
        };
        setSignatures([...signatures, newSig]);

        // Gọi message siêu đẹp của Ant Design
        message.success(`Đã thêm "${type}" vào Trang ${currentPage} thành công!`);
    };

    const updateSignature = (id: number, data: any) => {
        setSignatures(sigs => sigs.map(sig => sig.id === id ? { ...sig, ...data } : sig));
    };

    const toggleExpand = (id: number) => {
        setExpandedSigs(prev =>
            prev.includes(id) ? prev.filter(item => item !== id) : [...prev, id]
        );
    };

    const openSigningModal = (id: number) => {
        setCurrentSigningId(id);
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
        setCurrentSigningId(null);
        if (sigCanvasRef.current && typeof sigCanvasRef.current.clear === 'function') {
            sigCanvasRef.current.clear();
        }
    };

    const clearCanvas = () => {
        if (sigCanvasRef.current && typeof sigCanvasRef.current.clear === 'function') {
            sigCanvasRef.current.clear();
        }
    };

    const saveRealSignature = () => {
        if (sigCanvasRef.current && sigCanvasRef.current.isEmpty()) {
            alert("Vui lòng ký tên trước khi lưu.");
            return;
        }

        const rawDataUrl = sigCanvasRef.current.getCanvas().toDataURL('image/png');
        const img = new Image();
        img.onload = () => {
            const canvas = document.createElement('canvas');
            canvas.width = img.width;
            canvas.height = img.height;
            const ctx = canvas.getContext('2d');
            if (ctx) {
                ctx.drawImage(img, 0, 0);
                const pngDataUrl = canvas.toDataURL('image/png');
                setSignatures(sigs => sigs.map(sig =>
                    sig.id === currentSigningId ? { ...sig, realSignature: pngDataUrl } : sig
                ));
                closeModal();
            }
        };
        img.src = rawDataUrl;
    };

    const handleSaveAll = async () => {
        const signedSigs = signatures.filter(s => s.realSignature);
        if (signedSigs.length === 0) {
            alert("Bạn chưa ký chữ ký thật nào cả!");
            return;
        }

        try {
            alert("Đang xử lý nhúng chữ ký vào PDF... Vui lòng đợi!");
            const existingPdfBytes = await fetch('/images/hop-dong-mau.pdf').then(res => res.arrayBuffer());
            const pdfDoc = await PDFDocument.load(existingPdfBytes);
            const pages = pdfDoc.getPages();

            for (const sig of signedSigs) {
                if (!sig.realSignature) continue;
                const imgBytes = await fetch(sig.realSignature).then(res => res.arrayBuffer());
                const pngImage = await pdfDoc.embedPng(imgBytes);

                const page = pages[sig.page - 1];
                const { width: pdfWidth, height: pdfHeight } = page.getSize();

                const scale = pdfWidth / 792;
                const finalWidth = sig.width * scale;
                const finalHeight = sig.height * scale;
                const finalX = sig.x * scale;
                const finalY = pdfHeight - (sig.y * scale) - finalHeight;

                page.drawImage(pngImage, {
                    x: finalX,
                    y: finalY,
                    width: finalWidth,
                    height: finalHeight,
                });
            }

            const pdfBytes = await pdfDoc.save();
            const blob = new Blob([pdfBytes], { type: 'application/pdf' });
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = 'hop-dong-da-ky-hoan-tat.pdf';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            alert("Đã lưu và tải file thành công!");
            window.location.href = '/expense';
        } catch (error) {
            console.error("Lỗi khi xuất PDF:", error);
            alert("Có lỗi xảy ra khi tạo PDF.");
        }
    };

    const handleDownloadPDF = () => {
        const link = document.createElement('a');
        link.href = '/images/hop-dong-mau.pdf';
        link.download = 'hop-dong-mau-da-ky.pdf';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const handlePrintPDF = () => {
        const iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        iframe.src = '/images/hop-dong-mau.pdf';
        document.body.appendChild(iframe);
        iframe.onload = () => {
            if (iframe.contentWindow) {
                iframe.contentWindow.focus();
                iframe.contentWindow.print();
            }
            setTimeout(() => { document.body.removeChild(iframe); }, 5000);
        };
    };

    const handleZoomOut = () => {
        setZoom(prev => {
            const current = parseInt(prev);
            const next = current - 25;
            return next >= 50 ? next.toString() : '50';
        });
    };

    const handleZoomIn = () => {
        setZoom(prev => {
            const current = parseInt(prev);
            const next = current + 25;
            return next <= 200 ? next.toString() : '200';
        });
    };

     useImperativeHandle(ref, () => ({
        handleSaveAll,
    }));

    return (
        <div style={styles.container}>
            <header style={styles.header}>
                <div style={styles.headerLeft}>
                    <span style={styles.iconBtn} onClick={() => setShowThumbnails(!showThumbnails)} title="Ẩn/Hiện danh sách trang">
                        <Menu size={18} />
                    </span>
                    <div style={styles.fileName}>
                        <span>hop-dong-mau.pdf</span>
                    </div>
                </div>
                <div style={styles.headerCenter}>
                    <span>{currentPage} / {numPages}</span>
                    <span>|</span>
                    <span style={styles.iconBtn} onClick={handleZoomOut}>&#8722;</span>
                    <select style={styles.zoomSelect} value={zoom} onChange={(e) => setZoom(e.target.value)}>
                        <option style={styles.zoomOption} value="50">50%</option>
                        <option style={styles.zoomOption} value="100">100%</option>
                        <option style={styles.zoomOption} value="150">150%</option>
                        <option style={styles.zoomOption} value="200">200%</option>
                    </select>
                    <span style={styles.iconBtn} onClick={handleZoomIn}>&#43;</span>
                </div>
                <div style={styles.headerRight}>
                    <span style={styles.iconBtn} title="Tải xuống" onClick={handleDownloadPDF}><Download size={18} color="white" /></span>
                    <span style={styles.iconBtn} title="In" onClick={handlePrintPDF}><Printer size={18} color="white" /></span>
                    <span style={styles.iconBtn} onClick={() => setShowTools(!showTools)} title="Ẩn/Hiện công cụ">
                        <Settings size={18} />
                    </span>
                </div>
            </header>

            <main style={styles.main}>
                {showThumbnails && (
                    <aside style={styles.thumbnailSidebar}>
                        <Document file="/images/hop-dong-mau.pdf">
                            {thumbnails.map((item) => (
                                <div
                                    key={item.page}
                                    style={{ ...styles.thumbnailItem, ...(currentPage === item.page ? styles.thumbnailActive : {}) }}
                                    onClick={() => setCurrentPage(item.page)}
                                >
                                    <div style={{ width: '100%', backgroundColor: 'white', border: '1px solid #eee', overflow: 'hidden' }}>
                                        <Page pageNumber={item.page} width={90} renderTextLayer={false} renderAnnotationLayer={false} />
                                    </div>
                                    <span style={styles.thumbnailText}>{item.text}</span>
                                </div>
                            ))}
                        </Document>
                    </aside>
                )}

                <section style={styles.pdfViewer}>
                    <div style={{
                        ...styles.pdfPage,
                        height: `${(794 * pageSize.height) / pageSize.width}px`,
                        transform: `scale(${parseInt(zoom) / 100})`,
                        transformOrigin: 'top center'
                    }}>
                        <div style={{ width: '100%', height: '100%', display: 'flex', justifyContent: 'center' }}>
                            <Document file="/images/hop-dong-mau.pdf" onLoadSuccess={onDocumentLoadSuccess}>
                                <Page
                                    pageNumber={currentPage}
                                    width={792}
                                    renderTextLayer={false}
                                    renderAnnotationLayer={false}
                                    onLoadSuccess={(page) => {
                                        const viewport = page.getViewport({ scale: 1 });
                                        setPageSize({ width: viewport.width, height: viewport.height });
                                    }}
                                />
                            </Document>
                        </div>

                        {signatures.filter(sig => sig.page === currentPage).map(sig => (
                            <Rnd
                                key={sig.id}
                                size={{ width: sig.width, height: sig.height }}
                                position={{ x: sig.x, y: sig.y }}
                                bounds="parent"
                                style={{
                                    ...styles.sigBox,
                                    ...(sig.realSignature ? styles.sigBoxSigned : {})
                                }}
                                disableDragging={isModalOpen}
                                onDragStop={(e, d) => updateSignature(sig.id, { x: d.x, y: d.y })}
                                onResizeStop={(e, direction, ref, delta, position) => {
                                    updateSignature(sig.id, { width: parseInt(ref.style.width), height: parseInt(ref.style.height), ...position });
                                }}
                            >
                                <button
                                    style={styles.sigDelete}
                                    onPointerDown={(e) => {
                                        e.stopPropagation();
                                    }}
                                    onPointerUp={(e) => {
                                        e.stopPropagation();
                                        setSignatures(sigs => sigs.filter(s => s.id !== sig.id));
                                    }}
                                    title="Xóa"
                                >
                                    ✕
                                </button>

                                {sig.realSignature ? (
                                    <>
                                        <img
                                            src={sig.realSignature}
                                            alt="Chữ ký"
                                            style={styles.signedImage}
                                            onPointerUp={(e) => {
                                                e.stopPropagation();
                                                openSigningModal(sig.id);
                                            }}
                                        />
                                        <div style={styles.sigDragHandle} title="Kéo">✛</div>
                                    </>
                                ) : (
                                    /* Bỏ sự kiện click ở khung div ngoài, chỉ tập trung kéo thả */
                                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', width: '100%', height: '100%' }}>
                                        <span style={styles.sigRole}>{sig.signer.split(' - ')[0]}</span>
                                        <span style={styles.sigType}>{sig.type}</span>
                                        <span
                                            style={styles.sigClickToSign}
                                            onPointerUp={(e) => {
                                                e.stopPropagation();
                                                openSigningModal(sig.id);
                                            }}
                                        >
                                            Ký ngay
                                        </span>
                                    </div>
                                )}
                            </Rnd>
                        ))}
                    </div>
                </section>

                {showTools && (
                    <aside style={styles.toolsSidebar}>
                        <div style={styles.toolsTabHeader}>
                            <div style={{ ...styles.toolsTabItem, ...(activeTab === 'tools' ? styles.toolsTabItemActive : {}) }} onClick={() => setActiveTab('tools')}>
                                Công cụ
                            </div>
                            <div style={{ ...styles.toolsTabItem, ...(activeTab === 'zones' ? styles.toolsTabItemActive : {}) }} onClick={() => setActiveTab('zones')}>
                                Vùng ký ({signatures.length})
                            </div>
                        </div>

                        <div style={styles.toolsTabContent}>
                            {activeTab === 'tools' && (
                                <>
                                    <div style={styles.section}>
                                        <label style={styles.sectionTitle}>1. Chọn người ký</label>
                                        <div style={styles.profileSelector}>
                                            <div style={styles.profileAvatar}>👤</div>
                                            <select style={styles.realSelect} value={selectedSigner} onChange={(e) => setSelectedSigner(e.target.value)}>
                                                <option value="Giám đốc - Nguyễn Văn A">Giám đốc - A</option>
                                                <option value="Trưởng phòng - Lê Thị B">Trưởng phòng - B</option>
                                                <option value="Kế toán - Trần Văn C">Kế toán - C</option>
                                            </select>
                                        </div>
                                    </div>

                                    <div style={styles.section}>
                                        <label style={styles.sectionTitle}>2. Thêm chữ ký (Trang {currentPage})</label>
                                        <div style={styles.signatureOptions}>
                                            <button style={styles.signatureBtn} onClick={() => handleAddSignature('Ký chính')}>
                                                <span style={styles.signatureIcon}>✍️</span>
                                                <span style={styles.signatureText}>Ký chính</span>
                                            </button>
                                            <button style={styles.signatureBtn} onClick={() => handleAddSignature('Ký nháy')}>
                                                <span style={styles.signatureIcon}>📌</span>
                                                <span style={styles.signatureText}>Ký nháy</span>
                                            </button>
                                        </div>
                                    </div>
                                </>
                            )}

                            {activeTab === 'zones' && (
                                <div style={{ fontSize: '13px', color: '#666' }}>
                                    <div style={{ marginBottom: '12px', fontWeight: 'bold', color: '#333' }}>Danh sách ({signatures.length})</div>
                                    {signatures.map((sig) => {
                                        const isExpanded = expandedSigs.includes(sig.id);
                                        const role = sig.signer.split(' - ')[0];
                                        return (
                                            <div key={sig.id} style={styles.accItem}>
                                                <div style={styles.accHeader} onClick={() => toggleExpand(sig.id)}>
                                                    <div style={styles.accHeaderLeft}>
                                                        <div style={styles.accIcon}>✍️</div>
                                                        <div style={styles.accTitleArea}>
                                                            <span style={styles.accTitleMain}>{sig.type} | {role}</span>
                                                            <span style={styles.accTitleSub}>Trang {sig.page} {sig.realSignature ? '- Đã ký' : ''}</span>
                                                        </div>
                                                    </div>
                                                    <div style={styles.accToggleBtn}>{isExpanded ? <ChevronUp size={16} /> : <ChevronDown size={16} />}</div>
                                                </div>
                                                {isExpanded && (
                                                    <div style={styles.accBody}>
                                                        {sig.realSignature ? (
                                                            <img src={sig.realSignature} alt="Chữ ký" style={styles.accImageReal} />
                                                        ) : (
                                                            <div style={styles.accImagePlaceholder}>🖼️</div>
                                                        )}
                                                        <button style={styles.accDeleteBtn} onClick={(e) => { e.stopPropagation(); setSignatures(sigs => sigs.filter(s => s.id !== sig.id)); }}>
                                                            <Trash2 size={16} color="#dc3545" />
                                                        </button>
                                                    </div>
                                                )}
                                            </div>
                                        );
                                    })}
                                </div>
                            )}
                        </div>
                    </aside>
                )}
            </main>

            {/* <footer style={styles.footer}>
                <button style={{ ...styles.footerBtn, ...styles.saveBtn }} onClick={handleSaveAll}>Lưu hoàn tất</button>
                <button style={{ ...styles.footerBtn, ...styles.cancelBtn }} onClick={() => { if (window.confirm('Xóa hết?')) setSignatures([]) }}>Hủy</button>
            </footer> */}

            {isModalOpen && (
                <div
                    style={styles.modalOverlay}
                    onClick={(e) => {
                        if (e.target === e.currentTarget) {
                            closeModal();
                        }
                    }}
                >
                    <div style={styles.modalContent} onClick={(e) => e.stopPropagation()}>
                        <div style={styles.modalTitle}>Ký tên / Tải ảnh</div>

                        <div style={styles.signatureCanvasArea}>
                            <SignatureCanvas
                                ref={sigCanvasRef}
                                penColor='#000080'
                                canvasProps={{ width: 330, height: 130, className: 'sigCanvas' }}
                            />
                        </div>

                        <div style={{ marginBottom: '14px', textAlign: 'center' }}>
                            <input
                                type="file"
                                id="upload-sig-image"
                                accept="image/png, image/jpeg, image/jpg"
                                style={{ display: 'none' }}
                                onChange={(e) => {
                                    const file = e.target.files?.[0];
                                    if (file) {
                                        const reader = new FileReader();
                                        reader.onload = (uploadEvent) => {
                                            const result = uploadEvent.target?.result as string;
                                            if (result) {
                                                const img = new Image();
                                                img.onload = () => {
                                                    const canvas = document.createElement('canvas');
                                                    canvas.width = img.width;
                                                    canvas.height = img.height;
                                                    const ctx = canvas.getContext('2d');
                                                    if (ctx) {
                                                        ctx.drawImage(img, 0, 0);
                                                        const pngDataUrl = canvas.toDataURL('image/png');
                                                        setSignatures(sigs => sigs.map(sig =>
                                                            sig.id === currentSigningId ? { ...sig, realSignature: pngDataUrl } : sig
                                                        ));
                                                        closeModal();
                                                    }
                                                };
                                                img.src = result;
                                            }
                                        };
                                        reader.readAsDataURL(file);
                                    }
                                }}
                            />
                            <label htmlFor="upload-sig-image" style={{ display: 'inline-block', padding: '6px 12px', backgroundColor: '#e6f0fa', color: '#3E91AB', borderRadius: '4px', cursor: 'pointer', fontSize: '13px', fontWeight: 'bold', border: '1px solid #b3d1ff' }}>
                                📷 Tải ảnh/Chụp hình
                            </label>
                        </div>

                        <div style={styles.modalActions}>
                            <button style={{ ...styles.modalBtn, ...styles.modalBtnClear }} onClick={clearCanvas}>Xóa</button>
                            <button style={{ ...styles.modalBtn }} onClick={closeModal}>Đóng</button>
                            <button style={{ ...styles.modalBtn, ...styles.modalBtnPrimary }} onClick={saveRealSignature}>Lưu</button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
});
export default DocumentSign;